import './style.scss';

import React from 'react';
import Modal from 'react-modal';

function ModalContainer(props) {
  const className =
    'modal-content modal-content--flush' +
    (props.inverse ? ' modal-content--inverse' : '') +
    (props.className ? ` ${props.className}` : '');

  return (
    <Modal
      overlayClassName="modal-overlay"
      isOpen={props.isOpen}
      className={className}
      onRequestClose={props.handleClose}
      shouldCloseOnOverlayClick={true}
      onAfterOpen={props.handleAfterOpen}
      contentLabel={props.contentLabel || ''}
      ariaHideApp={false}
    >
      <div className="modal__close" onClick={props.handleClose}>
        ✕
      </div>
      {props.children}
    </Modal>
  );
}

export default ModalContainer;



// WEBPACK FOOTER //
// ./shared/components/ui/modal/index.js